import {authApi as api} from "./auth-api.service";

export class FaqsService {
    static async getFaqs() {
        return api.get("faq");
    }
}
